export default "/_next/static/images/ollie-5e33050a16b6fec54734728bc73dc56a.png";